import { InjectionToken } from '@angular/core';

export const SSO_BASE_URL = new InjectionToken<string>('SSO_BASE_URL');
